import { React } from 'react';
import { FaFacebook, FaLinkedin, FaInstagram } from 'react-icons/fa';



const SocialMedia = () => {
    return (
        <div className="social-media">
        <a href="https://www.indiamart.com/indelecttechonologies/" target="_blank" rel="noreferrer" aria-label="Visit Indelect on IndiaMART">
          <img src="../../assets/logos/indiamart.svg" height="60px" width="60px" alt="India Mart Logo"/>
        </a>
        <a href="https://www.facebook.com/pages/category/Community/Indelect-TechnologiesPvtLtd-144370088984560/" target="_blank" rel="noreferrer" aria-label="Visit Indelect on Facebook">
          <FaFacebook aria-hidden="true" focusable="false" />
        </a>
        <a href="https://www.instagram.com/p/CVA2AF1Buse/?utm_medium=copy_link" target="_blank" rel="noreferrer" aria-label="Visit Indelect on Instagram">
          <FaInstagram aria-hidden="true" focusable="false" />
        </a>
        <a href="https://www.linkedin.com/company/indelect-technologies-pvt-ltd/about/" target="_blank" rel="noreferrer" aria-label="Visit Indelect on LinkedIn">
          <FaLinkedin aria-hidden="true" focusable="false" />
        </a>
        <a href="https://www.jdmart.com/GOJ-ENZ1631687855?skip" target="_blank" rel="noreferrer" aria-label="Visit Indelect on Justdial">
          <img src="../../assets/logos/justdial.png" height="40px" width="100px" alt="Just Dial Logo"/>
        </a>
      </div>
    )
}

export default SocialMedia;